import React, { useEffect, useRef, useState } from 'react';
import hljs from 'highlight.js/lib/common';

import './CodeBlock.css';

const CodeBlock = ({ fields }) => {
  const [copied, setCopied] = useState(false);
  const codeString = fields?.Code?.value ?? '';
  const codeRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const widgetClasses = ["o-widget", "c-CodeBlock"];

  if (fields?.EnableVerticalOverflow?.value) widgetClasses.push("vertical-overflow");
  if (fields?.EnableExpandButton?.value) widgetClasses.push("expand-button-enabled");

  useEffect(() => {
    if (!codeRef.current) return;

    let src = (fields?.Code?.value ?? '').replace(/\r\n/g, '\n');

    if (/<\/?p[\s>]|<br\s*\/?>/i.test(src)) {
      src = src
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>\s*<p>/gi, '\n')
        .replace(/^<p>/i, '')
        .replace(/<\/p>$/i, '');
    }

    codeRef.current.textContent = src;

    hljs.highlightElement(codeRef.current);
  }, [fields?.Code?.value]);
  const toggleExpand = () => setIsExpanded((v) => !v);

  const copyToClipboard = async () => {
    try {
      const toCopy = codeString?.toString() ?? '';
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(toCopy);
      } else {
        // Fallback for older browsers
        const ta = document.createElement('textarea');
        ta.value = toCopy;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      var timeout = setTimeout(() => setCopied(false), 1600);
      return () => {
        clearTimeout(timeout);
      };
    } catch (e) {
     
    }
  };

  return (
    <div data-component="CodeBlock" className={widgetClasses.join(' ')} style={isExpanded ? { maxWidth: 'none' } : undefined}>
      <div className="c-CodeBlock__wrap">
        
        <div className="c-CodeBlock__actions" aria-label="Code block actions">
          <button
            type="button"
            className="expandTag"
            onClick={toggleExpand}
            aria-pressed={isExpanded}
            aria-label={isExpanded ? 'Collapse code block' : 'Expand code block'}
            title={isExpanded ? 'Collapse' : 'Expand'}
          >
            <i className={isExpanded ? 'fa fa-compress' : 'fa fa-expand'} aria-hidden="true"></i>
          </button>

          <button
          type="button"
          className="copyTag"
          onClick={copyToClipboard}
          aria-label="Copy code to clipboard"
          title={copied ? 'Copied!' : 'Copy'}
        >
          <i className={copied ? 'fa fa-check' : 'fa fa-copy'} aria-hidden="true"></i>
        </button>
        </div>
        <pre className="c-CodeBlock__content">
          <code ref={codeRef} className="c-CodeBlock__description" />
        </pre>
        <span className="sr-only" aria-live="polite" aria-atomic="true">
          {copied ? 'Code copied to clipboard' : ''}
        </span>
      </div>
    </div>
  );
};

export default CodeBlock;